// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._4t3igktf{height:20px}`, "",{"version":3,"sources":["webpack://./node_modules/@atlassian/people-teams-ui/dist/esm/common/ui/directory/person-card-grid/person-card/index.compiled.css"],"names":[],"mappings":"AAAA,WAAW,WAAW","sourcesContent":["._4t3igktf{height:20px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
